<div class="roles-page-container">
    <!-- Page Header -->
    <div class="page-header">
        <div class="header-left">
            <div class="header-title">
                <h1>User Roles</h1>
                <p>Total Roles: {{ totalRoles }}</p>
            </div>
        </div>
    </div>

    <!-- Search Bar -->
    <div class="search-section" *ngIf="totalRoles !== 0">
        <div class="search-container">
            <div class="search-controls">
                <form class="search-block" (submit)="onSearchSubmit()">
                    <div class="search-input">
                        <input type="text" name="search" [(ngModel)]="searchInput" placeholder="Search by Role name">
                    </div>
                    <button type="submit" class="icon-btn">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.2513 12.9228L16.8527 14.5242C17.4953 15.1668 17.4953 16.2086 16.8527 16.8512C16.2101 17.4938 15.1683 17.4938 14.5257 16.8512L12.9243 15.2498M0.667969 7.74984C0.667969 3.83782 3.83929 0.666504 7.7513 0.666504C11.6633 0.666504 14.8346 3.83782 14.8346 7.74984C14.8346 11.6619 11.6633 14.8332 7.7513 14.8332C3.83929 14.8332 0.667969 11.6619 0.667969 7.74984Z" stroke="white" stroke-width="1.25" stroke-linecap="round"/>
                        </svg>
                    </button>
                </form>
                <button type="button" class="reset-btn" (click)="reset($event)">
                    Reset
                </button>
            </div>
            <div class="action-buttons">
                <a class="add-role-btn" routerLink="/roles/create">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8 1.33333V14.6667M1.33333 8H14.6667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    Add New Role
                </a>
            </div>
        </div>
    </div>
    <!-- Roles Content -->
    <div *ngIf="totalRoles !== 0" class="roles-content d-flex gap-3">
        <div class="role-wrapper">
            <ul class="text-capitalize text-para text-dark app-border-grey">
                <li class="px-3 py-2 cursor-pointer" [ngClass]="currentRoleId === role.id ? 'active' : ''" *ngFor="let role of roles; index as i" (click)="onRoleChange(role.id)">
                    {{ role.name }}
                </li>
            </ul>
        </div>
        <div class="flex-grow-1 app-border-grey">
            <div class="">
                <div class="px-3 pt-2 d-flex align-items-center justify-content-between">
                    <h4 class="text-heading-4 text-dark text-capitalize">
                        {{ roleDetails?.name }}
                    </h4>
                    <div class="d-flex align-items-center gap-2">
                        <a class="primary-btn text-button" [routerLink]="'/roles/edit/'+ currentRoleId">
                            Edit
                        </a>
                        <a class="primary-btn text-button" routerLink="/roles/create">
                            Delete
                        </a>
                    </div>
                </div>
                <!-- tabs -->
                <div class="d-flex align-items-center app-border-grey--bottom">
                    <div class="tab-link current" data-id="tab-web" (click)="onTabClick($event, 'tab-web')">
                        <h5 class="text-heading-5 text-light-dark cursor-pointer px-3 py-2">Web App Permissions</h5>
                    </div>
                    <div class="tab-link" data-id="tab-hardware" (click)="onTabClick($event, 'tab-hardware')">
                        <h5 class="text-heading-5 text-light-dark cursor-pointer px-3 py-2">Hardware Permissions</h5>
                    </div>
                </div>
                <!-- tab content -->
                <div class="permissions-wrapper p-3">
                    <div id="tab-web" class="tab-content current">
                        <div class="d-flex gap-5 permission-group-wrapper py-3" *ngFor="let permissionGroup of permissions.web.groups; index as i">
                            <div class="permission-group d-flex align-items-start justify-content-between">
                                <div class="text-para text-light-dark">{{ i+1 }}. {{ permissionGroup.name }}</div>
                                <div class="d-flex align-items-center">
                                    <input type="checkbox" [id]="permissionGroup.name" (change)="onGroupPermissionChecked($event, i, 'web')" [(ngModel)]="permissionGroup.isChecked" disabled/>
                                    <label [for]="permissionGroup.name"></label>
                                    <span class="ms-3 text-para text-light-dark">{{ permissionGroup.isChecked ? 'Yes' : 'No' }}</span>
                                </div>
                            </div>
                            <div class="flex-grow-1 px-4">
                                <div class="d-flex align-items-start justify-content-between mb-3" *ngFor="let permission of permissionGroup.permissions">
                                    <div class="text-para text-light-dark">{{ permission.name }}</div>
                                    <div class="d-flex align-items-center">
                                        <input type="checkbox" [(ngModel)]="permission.isChecked" [id]="permission.u_name" (change)="onPermissionChecked($event, i, 'web')" disabled/>
                                        <label [for]="permission.u_name"></label>
                                        <span class="ms-3 text-para text-light-dark">{{ permission.isChecked ? 'Yes' : 'No' }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="tab-hardware" class="tab-content">
                        <div class="d-flex gap-5 permission-group-wrapper py-3" *ngFor="let permissionGroup of permissions.hardware.groups; index as i">
                            <div class="permission-group d-flex align-items-start justify-content-between">
                                <div class="text-para text-light-dark">{{ i+1 }}. {{ permissionGroup.name }}</div>
                                <div class="d-flex align-items-center">
                                    <input type="checkbox" [id]="permissionGroup.name" (change)="onGroupPermissionChecked($event, i, 'hardware')" [(ngModel)]="permissionGroup.isChecked" disabled/>
                                    <label [for]="permissionGroup.name"></label>
                                    <span class="ms-3 text-para text-light-dark">{{ permissionGroup.isChecked ? 'Yes' : 'No' }}</span>
                                </div>
                            </div>
                            <div class="flex-grow-1 px-4">
                                <div class="d-flex align-items-start justify-content-between mb-3" *ngFor="let permission of permissionGroup.permissions">
                                    <div class="text-para text-light-dark">{{ permission.name }}</div>
                                    <div class="d-flex align-items-center">
                                        <input type="checkbox" [(ngModel)]="permission.isChecked" [id]="permission.u_name" (change)="onPermissionChecked($event, i, 'hardware')" disabled/>
                                        <label [for]="permission.u_name"></label>
                                        <span class="ms-3 text-para text-light-dark">{{ permission.isChecked ? 'Yes' : 'No' }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- No Roles State -->
    <div *ngIf="totalRoles === 0" class="no-roles-state">
        <div class="no-roles-content">
            <svg class="no-roles-icon" width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="40" cy="40" r="40" fill="#F3F4F6"/>
                <path d="M40 20C45.5228 20 50 24.4772 50 30C50 35.5228 45.5228 40 40 40C34.4772 40 30 35.5228 30 30C30 24.4772 34.4772 20 40 20Z" fill="#9CA3AF"/>
                <path d="M40 45C30.335 45 22.5 52.835 22.5 62.5H57.5C57.5 52.835 49.665 45 40 45Z" fill="#9CA3AF"/>
            </svg>
            <h2 class="no-roles-title">No roles available</h2>
            <p class="no-roles-description">There are no roles in the system yet. Create your first role to get started.</p>
            <a class="create-first-role-btn" routerLink="/roles/create">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 1.33333V14.6667M1.33333 8H14.6667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                Create First Role
            </a>
        </div>
    </div>
</div>


